import React from 'react';
import { Users, Package, Calendar, Gift } from 'lucide-react';

const BRAND = {
  turquoise: '#81CBD6',
  pink: '#F39DB2',
  yellow: '#FFD16F',
};

export const HowItWorksSection = ({ theme, t, scrollY }) => {
  const steps = [
    { num: '01', icon: Users, title: t.howItWorks.step1, desc: t.howItWorks.step1Desc, color: BRAND.turquoise },
    { num: '02', icon: Package, title: t.howItWorks.step2, desc: t.howItWorks.step2Desc, color: BRAND.pink },
    { num: '03', icon: Calendar, title: t.howItWorks.step3, desc: t.howItWorks.step3Desc, color: BRAND.yellow },
    { num: '04', icon: Gift, title: t.howItWorks.step4, desc: t.howItWorks.step4Desc, color: BRAND.turquoise },
  ];

  return (
    <section 
      className="py-24 relative overflow-hidden hidden md:block" 
      style={{ backgroundColor: theme.bgSecondary }}
    >
      {/* Parallax Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div 
          className="absolute w-64 h-64 rounded-full blur-[100px] opacity-10" 
          style={{ 
            background: BRAND.turquoise, 
            top: '10%', 
            left: '5%', 
            transform: `translateY(${scrollY * 0.1}px)` 
          }} 
        />
        <div 
          className="absolute w-48 h-48 rounded-full blur-[80px] opacity-10" 
          style={{ 
            background: BRAND.pink, 
            bottom: '20%', 
            right: '10%', 
            transform: `translateY(${scrollY * -0.05}px)` 
          }} 
        />
      </div>
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="text-sm font-bold" style={{ color: BRAND.pink }}>
            {t.howItWorks.title}
          </span>
          <h2 className="text-3xl md:text-4xl font-black mt-2">
            {t.howItWorks.subtitle}
          </h2>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, i) => (
            <div key={i} className="text-center group cursor-pointer">
              <div 
                className="step-icon-wrapper w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center transition-all duration-200 group-hover:scale-110" 
                style={{ backgroundColor: `${step.color}15` }}
              >
                <step.icon 
                  className="step-icon w-10 h-10 transition-all duration-200" 
                  style={{ color: step.color }} 
                />
              </div>
              <span className="text-sm font-bold" style={{ color: theme.textMuted }}>
                {step.num}
              </span>
              <h3 className="font-bold text-lg mt-1 mb-2">{step.title}</h3>
              <p className="text-sm" style={{ color: theme.textMuted }}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
